const mutations = {
  SET_MSTAR_OWNERSHIP(state, payload) {
    state.mstarOwnership = {
      ChartImage: payload.chartImage,
      PortfolioDate: payload.portfolioDate,
      MstarCategory: payload.mstarCategory
    };
  }
};

const getters = {
  mstarOwnershipData: state => state.mstarOwnership
};

const state = {
  mstarOwnership: null
};

export default {
  state,
  getters,
  mutations
};
